<template>
    <div class="btu-group">
        <template v-if="empty_load">
            <b-overlay class="d-inline-block" :show="loading">
                <b-button variant="success" @click="load_click"><b-icon-search></b-icon-search>{{$t('components.btnGroup.load')}}</b-button>
            </b-overlay>
        </template>
        <template v-if="empty_insert">
            <b-button variant="primary" @click="insert()"><b-icon-file></b-icon-file>{{$t('components.btnGroup.insert')}}</b-button>
        </template>
        <template v-if="empty_del&&deleteItems>0">
            <b-overlay class="d-inline-block" :show="deling">
                <b-button variant="danger" @click="del_click"><b-icon-trash></b-icon-trash>{{$t('components.btnGroup.delete')}}({{deleteItems}})</b-button>
            </b-overlay>
        </template>
        <template v-if="empty_input">
            <b-button variant="info" @click="input()">匯入</b-button>
        </template>
        <template v-if="empty_file">
            <b-overlay class="d-inline-block" :show="fileing">
                <b-button variant="info" @click="file">匯出</b-button>
            </b-overlay>
        </template>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'btnGroup',
        props: {
            load: Function,
            insert: Function,
            del: Function,
            deleteItems: Number,
            input: Function,
            file: Function,
        },
        data: function () {
            return {
                loading: false, deling: false, fileing: false
            }
        },
        computed: {
            empty_load: function () { return this.load; },
            empty_insert: function () { return this.insert; },
            empty_del: function () { return this.del; },
            empty_input: function () { return this.input; },
            empty_file: function () { return this.file; },
        },
        methods: {
            load_click: function () {
                this.loading = true;
                this.load().finally(() => this.loading = false);
            },
            del_click: function () {
                if (confirm('確定刪除?')) {
                    this.deling = true;
                    this.del().finally(() => this.deling = false);
                }
            },
            file_click: function () {
                this.fileing = true;
                this.file().finally(() => this.fileing = false);
            }
        }
    };
</script>

<style>
</style>